// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../config/api";
import config from "../config/config";
import { getCurrentLoggedInSessionToken, getCurrentLoggedInSessionTokenWithPromise } from "../config/userPool";

const {
  STAFF_REFERRAL_LISTING_ENDPOINT,
  STAFF_REFERRAL_EXPORT_ENDPOINT,
  STAFF_REFERRAL_UPDATE_STATUS_ENDPOINT,
  STAFF_REFERRAL_DETAIL_ENDPOINT,
  AUDIT_ENDPOINT,
} = config.api_endpoint;

const initialState = {
  loading: false,
  STAFF_REFERRAL_list: [],
  detail_loading: false,
  STAFF_REFERRAL_detail: {},
  error: null,
  audit_data: [],
};

export const fetchAllStaffReferralList = createAsyncThunk(
  "hr_connect/fetchAllStaffReferralList",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${STAFF_REFERRAL_LISTING_ENDPOINT}`;
      const results = await api.get(url, { ...data }, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchStaffReferralExportList = createAsyncThunk(
  "hr_connect/fetchStaffReferralExportList",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${STAFF_REFERRAL_EXPORT_ENDPOINT}`;
      const results = await api.get(url, { ...data }, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const updateStaffReferralStatus = createAsyncThunk(
  "hr_connect/updateStaffReferralStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${STAFF_REFERRAL_UPDATE_STATUS_ENDPOINT}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchStaffReferralDetail = createAsyncThunk(
  "hr_connect/fetchStaffReferralDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        STAFF_REFERRAL_DETAIL_ENDPOINT + "?id=" + id,
        {},
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchStaffReferralAudit = createAsyncThunk(
  "hr_connect/fetchStaffReferralAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = await getCurrentLoggedInSessionTokenWithPromise();
      const results = await api.get(
        `${AUDIT_ENDPOINT}?table_name=staff-referral&source_id=${id}`,
        {},
        token
      );
      return results;
    } catch (err) {
      return rejectWithValue(err.details);
    }
  }
);


const staffReferralSlice = createSlice({
  name: "StaffReferralList",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateStaffReferralStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStaffReferralStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateStaffReferralStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllStaffReferralList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllStaffReferralList.fulfilled, (state, action) => {
        state.loading = false;
        state.STAFF_REFERRAL_list = action.payload;
      })
      .addCase(fetchAllStaffReferralList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchStaffReferralDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchStaffReferralDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.STAFF_REFERRAL_detail = action.payload;
      })
      .addCase(fetchStaffReferralDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchStaffReferralAudit.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffReferralAudit.fulfilled, (state, action) => {
        state.loading = false;
        state.audit_data = action.payload.data;
      })
      .addCase(fetchStaffReferralAudit.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error.message;
      })

  },
});

const StaffReferralReducer = staffReferralSlice.reducer;
export default StaffReferralReducer;
